import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import Slider from 'react-slick';
import RenderStaticHTML from '../RenderStaticHTML';

const ns = `pdp-tabs`;

const PDPTabs = ({
	productName,
	aboutSupportsHeadlines,
	aboutDescriptionSummary,
	aboutDescriptionPoints,
	suggestedUse,
	supplementFacts,
	shippingDescription,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	const slickSettings = {
		dots: false,
		arrows: false,
		speed: 500,
		infinite: false,
		// variableWidth: true,
		slidesToShow: 1.2,
		slidesToScroll: 1,
		adaptiveHeight: true,
		mobileFirst: true,
	};

	/* SETUP GOOGLE EXPERIMENT CALLBACKS */
	const [variantPDPTabSlider, setVariantPDPTabSlider] = useState(true);

	useEffect(() => {
		window.enablePDPTabSlider = () => { setVariantPDPTabSlider(true); };
	}, []);
	/* END GOOGLE EXPERIMENT SETUP */

	const [activeTab, setActiveTab] = useState('about');
	const onClickTabItem = tab => {
		setActiveTab(tab);
	};

	const [isMobile, setMobile] = useState(null);
	useEffect(() => {
		setMobile(window.innerWidth < 1024);
		window.addEventListener('resize', () => {
			setMobile(window.innerWidth < 1024);
		});
		return () => {
			window.removeEventListener('resize', () => {});
		};
	}, []);

	const headerAbout = (clickable = false) => {
		const Element = clickable ? 'button' : 'div';
		const onClick = clickable ? () => { onClickTabItem('about'); } : null;
		return (
			<Element
				className={`${ ns }__tab ${ activeTab === 'about' ? 'active' : '' }`}
				onClick={onClick}
			>
				{`About ${ productName }`}
			</Element>
		);
	};
	const headerSuggestedUse = (clickable = false) => {
		const Element = clickable ? 'button' : 'div';
		const onClick = clickable ? () => { onClickTabItem('suggested'); } : null;
		return suggestedUse?.value && (
			<Element
				className={`${ ns }__tab ${ activeTab === 'suggested' ? 'active' : '' }`}
				onClick={onClick}
			>
				Suggested Use
			</Element>
		);
	};
	const headerShippingDescription = (clickable = false) => {
		const Element = clickable ? 'button' : 'div';
		const onClick = clickable ? () => { onClickTabItem('shipping'); } : null;
		return shippingDescription?.value && (
			<Element
				className={`${ ns }__tab ${ activeTab === 'shipping' ? 'active' : '' }`}
				onClick={onClick}
			>
				Shipping
			</Element>
		);
	};
	const headerSpacer = (clickable = false) => {
		const Element = clickable ? 'button' : 'div';
		const onClick = clickable ? () => { } : null;
		return (
			<Element
				className={`${ ns }__tab`}
				onClick={onClick}
			/>
		);
	};

	const contentAbout = (
		<div className={`${ ns }__about`}>
			<div className={`${ ns }__about-left`}>
				<div className={`${ ns }__about-title eyebrow`}>
					Healthy Benefits
				</div>
				{aboutSupportsHeadlines?.value && (
					<div className={`${ ns }__about-headlines`}>
						{aboutSupportsHeadlines.value.split('|').map(headline => {
							return (
								<div className={`${ ns }__about-headline h3`} key={headline}>
									{headline}
								</div>
							);
						})}
					</div>
				)}
			</div>
			<div className={`${ ns }__about-right`}>
				<div className={`${ ns }__about-summary`}>
					<RenderStaticHTML className={'wysiwyg'} html={aboutDescriptionSummary?.value} />
				</div>
				<div className={`${ ns }__about-points`}>
					<RenderStaticHTML className={'wysiwyg'} html={aboutDescriptionPoints?.value} />
				</div>
			</div>
		</div>
	);

	const contentSuggestedUse = (
		<div className={`${ ns }__suggested-use`}>
			<RenderStaticHTML className={'wysiwyg'} html={suggestedUse?.value} />
		</div>
	);

	const contentSupplementFacts = (
		<div className={`${ ns }__supplement-facts`}>
			<RenderStaticHTML className={'wysiwyg'} html={supplementFacts?.value} />
		</div>
	);

	const contentShippingDescription = (
		<div className={`${ ns }__shipping`}>
			<RenderStaticHTML className={'wysiwyg'} html={shippingDescription?.value} />
		</div>
	);

	return (
		<div className={`${ rootClassnames }`}>
			{(!isMobile || !variantPDPTabSlider) && (
				<div className={'container'}>
					<div className={`${ ns }__list-container`}>
						<div className={`${ ns }__list`}>
							{headerAbout(true)}
							{headerSuggestedUse(true)}
							{headerShippingDescription(true)}
							{headerSpacer(false)}
						</div>
					</div>
					<div className={`${ ns }__tab-content`}>
						{activeTab === 'about' && contentAbout}
						{activeTab === 'suggested' && contentSuggestedUse}
						{activeTab === 'supplement' && contentSupplementFacts}
						{activeTab === 'shipping' && contentShippingDescription}
					</div>
				</div>
			)}

			{variantPDPTabSlider && isMobile && (
				<div className={'container'}>
					<Slider {...slickSettings}>
						<div>
							{headerAbout()}
							<div className={`${ ns }__tab-content`}>
								{contentAbout}
							</div>
						</div>
						<div>
							{headerSuggestedUse()}
							<div className={`${ ns }__tab-content`}>
								{contentSuggestedUse}
							</div>
						</div>
						<div>
							{headerShippingDescription()}
							<div className={`${ ns }__tab-content`}>
								{contentShippingDescription}
							</div>
						</div>
					</Slider>
				</div>
			)}
		</div>
	);
};

export default PDPTabs;
